import { ActionType } from './actions';
import { initialState, IState } from './state';
import { ResourceModel } from '../../models';
import { preloadClient } from '../../../utils/clientUtils';

export const reducer = (state: IState = initialState, { type, payload }: { type: ActionType; payload?: any }): IState => {
  switch (type) {
    case ActionType.FETCH_CLIENT_LIST_SUCCESS:
      return {
        ...state,
        clientMap: payload.list.reduce(
          (total, item) => ({ ...total, [payload?.hasMultipleEntries && item.projectId && item.projectName ? `${item.id}_${item.projectId}` : item.id]: preloadClient(item) }),
          {}
        ),
        count: payload.count,
      };
    case ActionType.FETCH_CLIENT_HIERARCHY_SUCCESS:
      return {
        ...state,
        clientHierarchyMap: payload,
      };
    case ActionType.CLEAR_CLIENT_HIERARCHY:
      return { ...state, clientHierarchyMap: null };
    case ActionType.FETCH_CLIENT_BRANCHES_SUCCESS:
      return {
        ...state,
        clientBranchesMap: payload,
      };
    case ActionType.CLEAR_CLIENT_BRANCHES:
      return { ...state, clientBranchesMap: null };
    case ActionType.FETCH_ONBOARDING_CLIENT_LIST_SUCCESS:
      return { ...state, onboardingClientMap: payload.list.reduce((total, item) => ({ ...total, [item.id]: preloadClient(item) }), {}), count: payload.count };
    case ActionType.FETCH_SELF_COMPANY_SUCCESS:
      return { ...state, selfCompany: payload.company };
    case ActionType.FETCH_MERGE_COMPANY_SUMMARY_SUCCESS:
      return { ...state, mergeCompanySummaryMap: { ...state.mergeCompanySummaryMap, [payload.id]: payload.summary } };
    case ActionType.CLEAR_MERGE_COMPANY_SUMMARY:
      return { ...state, mergeCompanySummaryMap: {} };
    case ActionType.FETCH_ALL_ACTIVE_CLIENTS_SUCCESS:
      return { ...state, activeClients: payload.clients };
    case ActionType.FETCH_MERGE_COMPANY_PROJECT_SUMMARY_SUCCESS:
      return { ...state, mergeCompanyProjectSummaryMap: { ...state.mergeCompanyProjectSummaryMap, [payload.id]: payload.projectSummary } };
    case ActionType.FETCH_MERGE_COMPANY_USERS_SUCCESS:
      return { ...state, mergeCompanyUserMap: { ...state.mergeCompanyUserMap, [payload.id]: payload.users } };
    case ActionType.CLEAR_MERGE_COMPANY_PROJECT_SUMMARY:
      return { ...state, mergeCompanyProjectSummaryMap: {} };
    case ActionType.CLEAR_MERGE_COMPANY_USERS:
      return { ...state, mergeCompanyUserMap: {} };
    case ActionType.FETCH_MERGE_COMPANY_BILLING_SUMMARY_SUCCESS:
      return { ...state, mergeCompanyBillingSummaryMap: { ...state.mergeCompanyBillingSummaryMap, [payload.id]: payload.billingSummary } };
    case ActionType.CLEAR_MERGE_COMPANY_BILLING_SUMMARY:
      return { ...state, mergeCompanyBillingSummaryMap: {} };
    case ActionType.FETCH_MERGE_COMPANY_INVOICES_SUMMARY_SUCCESS:
      return { ...state, mergeCompanyInvoiceSummaryMap: { ...state.mergeCompanyInvoiceSummaryMap, [payload.id]: payload.invoicesSummary } };
    case ActionType.CLEAR_MERGE_COMPANY_INVOICES_SUMMARY:
      return { ...state, mergeCompanyInvoiceSummaryMap: {} };
    case ActionType.FETCH_MERGE_COMPANY_REVIEW_INVOICES_SUMMARY_SUCCESS:
      return { ...state, mergeCompanyReviewInvoiceSummaryMap: { ...state.mergeCompanyReviewInvoiceSummaryMap, [payload.id]: payload.reviewInvoicesSummary } };
    case ActionType.CLEAR_MERGE_COMPANY_REVIEW_INVOICES_SUMMARY:
      return { ...state, mergeCompanyReviewInvoiceSummaryMap: {} };
    case ActionType.FETCH_MERGE_COMPANY_INVOICES_SUCCESS:
      return { ...state, mergeCompanyInvoiceMap: { ...state.mergeCompanyInvoiceMap, [payload.id]: payload.invoices } };
    case ActionType.CLEAR_MERGE_COMPANY_INVOICES:
      return { ...state, mergeCompanyInvoiceMap: {} };
    case ActionType.FETCH_MERGE_COMPANY_WORKERS_SUCCESS:
      return { ...state, mergeCompanyWorkersMap: { ...state.mergeCompanyWorkersMap, [payload.id]: payload.workersSummary } };
    case ActionType.CLEAR_MERGE_COMPANY_WORKERS:
      return { ...state, mergeCompanyWorkersMap: {} };
    case ActionType.SAVE_SELECTED_MERGE_COMPANY_PROJECTS:
      return { ...state, selectedProjects: payload.selectedProjects };
    case ActionType.CLEAR_SELECTED_MERGE_COMPANY_PROJECTS:
      return { ...state, selectedProjects: null };
    case ActionType.SAVE_SELECTED_MERGE_COMPANY_USERS:
      return { ...state, selectedUsers: payload.selectedUsers };
    case ActionType.CLEAR_SELECTED_MERGE_COMPANY_USERS:
      return { ...state, selectedUsers: null };
    case ActionType.SAVE_SELECTED_MERGE_COMPANY_WORKERS:
      return { ...state, selectedWorkers: payload.selectedWorkers };
    case ActionType.CLEAR_SELECTED_MERGE_COMPANY_WORKERS:
      return { ...state, selectedWorkers: null };
    case ActionType.FETCH_MWBE_SUCCESS:
      return { ...state, mwbeList: payload.list };
    case ActionType.FETCH_TRADES_SUCCESS:
      return { ...state, tradeList: payload.list };
    case ActionType.INVITE_DRAFT_CLIENT_SUCCESS:
      return { ...state, clientMap: { [payload.client.id]: payload.client } };
    case ActionType.UPDATE_DRAFT_CLIENT_SUCCESS:
      return { ...state, clientMap: { ...state.clientMap, [payload.client.id]: payload.client } };
    case ActionType.CLEAR_CLIENT_MAP:
      return { ...state, clientMap: {}, clientProjectMap: {}, clientProjectHirearchyMap: {}, count: 0 };
    case ActionType.CLEAR_ONBOARDING_CLIENT_MAP:
      return { ...state, onboardingClientMap: {}, count: 0 };
    case ActionType.UPDATE_CLIENT_SUCCESS:
      const objectKey = payload.projectId ? `${payload.client.id}_${payload.projectId}` : payload.client.id;
      return { ...state, clientMap: { ...state.clientMap, [objectKey]: { ...(state.clientMap[objectKey] || {}), ...payload.client } } };
    case ActionType.UPDATE_ONBAORDING_CLIENT_SUCCESS:
      return {
        ...state,
        onboardingClientMap: { ...state.onboardingClientMap, [payload.client.id]: { ...state.onboardingClientMap[payload.client.id], ...payload.client } },
      };
    case ActionType.ARCHIVE_CLIENT_SUCCESS:
      return { ...state, clientMap: { ...state.clientMap, [payload.id]: { ...state.clientMap[payload.id], status: ResourceModel.CompanyStatus.ARCHIVED } } };
    case ActionType.UNARCHIVE_CLIENT_SUCCESS:
      return { ...state, clientMap: { ...state.clientMap, [payload.id]: { ...state.clientMap[payload.id], status: ResourceModel.CompanyStatus.ACTIVE } } };
    case ActionType.FETCH_PROJECT_CLIENT_HIREARCHY_LIST_SUCCESS:
      return { ...state, clientProjectHirearchyMap: payload.list.reduce((total, item) => ({ ...total, [item.id]: preloadClient(item) }), {}) };
    case ActionType.FETCH_PROJECT_CLIENT_LIST_SUCCESS:
      return {
        ...state,
        clientProjectMap: { [payload.projectId]: payload.list.reduce((total, item) => ({ ...total, [item.id]: item }), {}) },
        count: payload.count,
      };
    case ActionType.FETCH_PROJECT_CLIENT_SUMMARY_SUCCESS:
      return {
        ...state,
        clientProjectMap: {
          ...state.clientProjectMap,
          [payload.projectId]: {
            ...state.clientProjectMap[payload.projectId],
            [payload.client.id]: { ...state.clientProjectMap?.[payload.projectId]?.[payload.client.id], ...payload.client },
          },
        },
      };
    case ActionType.UPDATE_PROJECT_CLIENT_TAX_CONDITION_SUCCESS:
      return {
        ...state,
        clientProjectMap: {
          ...state.clientProjectMap,
          [payload.projectId]: {
            ...state.clientProjectMap[payload.projectId],
            [payload.clientId]: {
              ...state.clientProjectMap[payload.projectId][payload.clientId],
              isTaxExempt: payload.condition,
            },
          },
        },
      };
    case ActionType.FETCH_ADMIN_PERMISSION_SUCCESS:
      return {
        ...state,
        isGeneralAdmin: payload.isGeneralAdmin,
      };
    case ActionType.FETCH_USER_CLIENTS_SUCCESS:
      return {
        ...state,
        userClients: payload.list,
      };
    case ActionType.FETCH_PROJECT_COMPANY_SUCCESS:
      return {
        ...state,
        projectCompany: payload.client,
      };
    case ActionType.FETCH_JOINT_VENTURE_COMPANY_USERS_SUCCESS:
      return {
        ...state,
        jointVentureUserMap: { ...state.jointVentureUserMap, [payload.companyId]: payload.userList },
      };
    case ActionType.FETCH_SEARCH_INVITE_CLIENT_SUCCESS:
      return {
        ...state,
        clientsToInvite: payload.data,
      };
    case ActionType.FETCH_FAILED_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        failedTransactions: { list: payload.failedTransactions, isViewed: false },
      };
    case ActionType.VIEWED_FAILED_TRANSACTIONS:
      return {
        ...state,
        failedTransactions: { ...state.failedTransactions, isViewed: true },
      };
    case ActionType.FETCH_CLIENT_LIST_FOR_MULTIPLE_PROJECTS_SUCCESS:
      return {
        ...state,
        clientList: payload.list,
      };
    case ActionType.ADD_UNVERIFIED_COMPANIES_SUCCESS:
      return { ...state, clientMap: { [payload.client.id]: payload.client } };
    default:
      return state;
  }
};
